export default {
  view_all_contacts: 'Voir tous mes contacts',
};
